import React from "react"
import { Link } from "gatsby"
import { IoMdClose } from "react-icons/io"
import { MdChevronRight } from "react-icons/md"
import { eventTracking } from "../../services/tracking"
import linkBuilder from "../../modules/linkBuilder"
import { trackEvent } from "../../modules/analytics"
import ScrollCTA from "../scroll-cta/scroll-cta"

import {
  StickyCTA,
  StickyCTAContent,
  StickyCTATitle,
  StickyCTAAction,
  StickyCTAArrow,
} from "./sticky-cta.module.css"

const StickyCta = ({ 
  primaryCta, 
  article, 
  closedCta, 
  onCloseCTA, 
  primaryCtaStickyCta 
}) => {
  if (!primaryCta || closedCta) {
    return null
  }

  return (
    <ScrollCTA start={30} end={70}>
      <div className={StickyCTA}>
        <button 
          className={StickyCTAAction} 
          onClick={onCloseCTA}
          aria-label="Close sticky CTA"
          type="button"
        >
          <IoMdClose size={24} />
        </button>
        <div className={StickyCTAContent}>
          {article.sponsor && (
            <span>In samenwerking met: {article.sponsor.name}</span>
          )}

          {primaryCta.title && primaryCta.__typename !== 'ContentfulExternalLink' && (
            <Link
              to={linkBuilder.dynamic(primaryCta)}
              onClick={() => {
                trackEvent("cta_mobile_fixed_footer");
                eventTracking("click", {
                  contentfulId: primaryCta.contentful_id,
                  contentfulType: primaryCta.__typename,
                  contentfulTitle: primaryCta.title,
                  displayPageContentfulId: article.contentful_id,
                  displayPageTitle: article.title,
                  displayPagePath: linkBuilder.article(article),
                  displayPosition: "bottomScreenMobile",
                })
              }}
            >
              <span className={StickyCTATitle}>
                {primaryCtaStickyCta || primaryCta.title}
              </span>
              <div className={StickyCTAArrow}>
                <MdChevronRight size={40} />
              </div>
            </Link>
          )}

          {primaryCta.title && primaryCta.__typename == 'ContentfulExternalLink' && (
            <a href={primaryCta.url} target="_blank" rel="noopener noreferrer"
              onClick={async (event) => {
                trackEvent("cta_mobile_fixed_footer");
                eventTracking("click", {
                  contentfulId: primaryCta.contentful_id,
                  contentfulType: primaryCta.__typename,
                  contentfulTitle: primaryCta.title,
                  displayPageContentfulId: article.contentful_id,
                  displayPageTitle: article.title,
                  displayPagePath: linkBuilder.article(article),
                  displayPosition: "bottomScreenMobile",
                })
              }}
            >
              <span className={StickyCTATitle}>
                {primaryCtaStickyCta || primaryCta.title}
              </span>
              <div className={StickyCTAArrow}>
                <MdChevronRight size={40} />
              </div>
            </a>
          )}
        </div>
      </div>
    </ScrollCTA>
  )
}

export default StickyCta
